import React from 'react';
import ArrowBackIosRoundedIcon from '@mui/icons-material/ArrowBackIosRounded';
import { Box, Link, Stack, Typography } from '@mui/material';
import wordedLogo from '@stack/assets/images/logo-word.svg';
import wordedLogoLight from '@stack/assets/images/logo-word-light.svg';
import { useThemeSettings } from '@webbyx/mui';
import Image from 'next/image';
import NextLink from 'next/link';

import { AuthHeaderProps } from './props';

const AuthHeader = (props: AuthHeaderProps) => {
  const { title, titleProps, onBack, backButtonText, children } = props;
  const { settings } = useThemeSettings();
  // ================ VIEWS
  return (
    <Box>
      <Stack direction="row" spacing={2}>
        <Image
          height={36}
          alt="logo"
          src={settings.mode === 'light' ? wordedLogo : wordedLogoLight}
        />
      </Stack>
      <Box sx={{ mt: 12.5 }}>
        {onBack ? (
          <Link
            underline={'hover'}
            href="#"
            onClick={onBack}
            fontSize={16}
            component={NextLink}
            sx={{
              alignItems: 'center',
              display: 'flex',
              cursor: 'pointer',
              fontWeight: 500,
              mb: 2,
            }}
          >
            <ArrowBackIosRoundedIcon
              sx={{
                fontSize: '18px',
                marginRight: 2,
              }}
            />
            {backButtonText}
          </Link>
        ) : null}
        <Typography variant="h5" fontWeight={600} {...titleProps}>
          {title}
        </Typography>
      </Box>
      {children && <Box sx={{ mt: 1 }}>{children}</Box>}
    </Box>
  );
};

export default AuthHeader;
